module.exports = __webpack_public_path__ + "img/zuijia_29.8090b711.png";